module.exports = __webpack_public_path__ + "img/logo_MOFA.47468054.png";